var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG2234(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.672,
    height: 37.645,
    viewBox: "0 0 25.672 37.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#a00;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.a{stroke-miterlimit:6.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(874.209 434.911)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-871.976-414.187h21.206a1.228,1.228,0,0,1,1.233,1.229v29.192a1.228,1.228,0,0,1-1.233,1.229h-21.206a1.228,1.228,0,0,1-1.233-1.229v-29.192A1.228,1.228,0,0,1-871.976-414.187Z",
    transform: "translate(0 -15.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-872.764-428.6H-849.2",
    transform: "translate(-0.355 -4.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-847.834-394.011v23.474",
    transform: "translate(-20.234 -31.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-814.784-394.011v23.474",
    transform: "translate(-46.589 -31.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-781.734-394.011v23.474",
    transform: "translate(-72.943 -31.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-831.685-433.911h6.92",
    transform: "translate(-33.112)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2234);
export default __webpack_public_path__ + "static/media/g2234.15f3cd26bf1799518c8a1e209eab683b.svg";
export { ForwardRef as ReactComponent };